import { create } from 'zustand';

type State = {
  error?: string;
};

type Actions = {
  showError: (error: string) => void;
  hideError: () => void;
};

export const useModalError = create<State & Actions>((set) => ({
  showError: (value) => {
    set({ error: value });
  },
  hideError: () => {
    set({ error: undefined });
  },
}));
